import { Button, SaveIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useConfirm } from "melco-shared-logic";
import { useFormikContext } from "formik";



type EditEmailConfirmButtonProps = {

};

export const EditEmailConfirmButton: React.FC<
    EditEmailConfirmButtonProps
> = () => {
    const { t } = useTranslation();
    const { submitForm, values } = useFormikContext();

    const confirmEditEmail = useConfirm(
        async () => {

            submitForm();


        },
        {
            translationPrefix: "licenses.basic.detail.editemail",



        }
    );





    return (

        <>
            <Button
                icon={<SaveIcon />}
                type="primary"

                onClick={(values) => {

                    confirmEditEmail();

                }}
            >
                {t("global.button.save")}
            </Button></>
    );
};
